import { Footer } from "../components/Footer"
import { PriorityMethods } from "../components/deposit/PriorityMethods"
import { PaycashMethod } from "../components/deposit/PaycashMethod"


export const DepositPaycashPage = () => {
    return (
        <div className="container">
            <PriorityMethods />
            <PaycashMethod />
            <Footer />
        </div>
    );
}